<app-breadcrumb [title]="page_name" [breadcrumb]="page_name"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        {{'Profile' | translate}}
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back' | translate}}
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <li class="active"><a data-lng="es" href="/pages/notifications">
                                    {{'notifications' | translate}}
                                </a></li>
                            <li><a data-lng="es" href="/pages/my-orders">
                                    {{'Orders' | translate}}
                                </a></li>
                            <li>
                                <a data-lng="es" href="javascript:void(0)" (click)="userLogOut()">
                                    {{'logout' | translate}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="dashboard-right">
                    <div class="dashboard">
                        <div class="page-title table_hed">
                            <h2>{{page_name}}</h2>
                        </div>
                        <div class="welcome-msg">

                            <div class="row" *ngIf="datadone">
                                <div class="col-md-6">
                                    <h5># {{notificationDetails.id}} </h5>

                                    <h5>{{'Address' | translate}} : {{notificationDetails.admin_notification_title}}
                                    </h5>
                                    <h5>{{page_name}} : <br><br>
                                        <p [innerHtml]="notificationDetails.admin_notification_content"></p>
                                    </h5>

                                </div>

                            </div>

                        </div>
                        <div class="box-account box-info">


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section end -->

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>